<template>
  <div :class="['a5-page', 'a5-container', { 'p3-page': isChineseProduct }]">
    <template v-if="isChineseProduct">
      <div class="p3-subnav">
        <span>ANOVATOR {{ productContent.model }}</span>
        <a href="#contact-modal" @click.prevent="openContactModal">{{ productContent.demoLabel }}</a>
      </div>

      <section class="p3-hero">
        <img src="/static/images/product/p3/hero-4k.png" alt="" />
        <div class="p3-hero__copy">
          <h1>{{ productContent.heroTitle }}</h1>
          <p>{{ productContent.heroDescription }}</p>
        </div>
        <div v-show="showScrollMouse" class="p3-scroll-mouse">
          <img src="/static/images/mouse-w.png" alt="" />
          <span>{{ productContent.scrollLabel }}</span>
        </div>
      </section>

      <section class="p3-functions-section">
        <div class="p3-section-heading">
          <h2>{{ productContent.featuresTitle }}</h2>
          <p>{{ productContent.featuresDescription }}</p>
        </div>
        <div class="p3-function-grid">
          <span v-for="func in productContent.functions" :key="func">{{ func }}</span>
        </div>
      </section>

      <section
        v-for="section in p3FeatureSections"
        :key="section.key"
        :class="['p3-feature-section', `p3-feature-section--${section.key}`]"
      >
        <img :src="section.image" alt="" />
        <div :class="['p3-feature-copy', `p3-feature-copy--${section.align}`]">
          <template v-if="section.key === 'screen'">
            <p class="p3-number"><strong>32</strong><span>英寸</span></p>
          </template>
          <p v-if="section.kicker" class="p3-feature-kicker">{{ section.kicker }}</p>
          <h2>{{ section.title }}</h2>
          <p v-if="section.description" class="p3-feature-description">{{ section.description }}</p>
          <div v-if="section.metrics" class="p3-feature-metrics">
            <p v-for="metric in section.metrics" :key="metric.label">
              <strong>{{ metric.value }}</strong><span>{{ metric.label }}</span>
            </p>
          </div>
          <div v-if="section.key === 'posture'" class="p3-risk-list">
            <span v-for="risk in productContent.riskItems" :key="risk">{{ risk }}</span>
          </div>
        </div>
      </section>

      <section class="p3-medical-section">
        <h2>医疗级测评</h2>
        <div class="p3-medical-grid">
          <article>
            <img src="/static/images/product/p3/blood-pressure.png" alt="" />
            <h3>血压测量</h3>
            <p>医疗级血压测量，监测运动风险。关注高血压及女性经期运动风险，让运动更安心、更舒适。</p>
          </article>
          <article>
            <img src="/static/images/product/p3/blood-oxygen.png" alt="" />
            <h3>血氧</h3>
            <p>测量1分钟静息心率与血氧浓度，评估心肺功能水平，为日常训练强度规划提供精准的数据支持。</p>
          </article>
        </div>
      </section>

      <section class="p3-services-section">
        <header>
          <h2>配套服务</h2>
          <p>精准的数据采集只是一个开始</p>
        </header>
        <article v-for="(card, index) in productContent.serviceCards" :key="card.title" :class="{ reverse: index % 2 === 1 }">
          <div class="p3-service-copy">
            <span>0{{ index + 1 }}</span>
            <h3>{{ card.title }}</h3>
            <p v-for="description in card.descriptions" :key="description">{{ description }}</p>
          </div>
          <img :src="card.image" alt="" />
        </article>
      </section>

      <section class="p3-compare-section">
        <PSeriesCompare fixed-key="p3" initial-comparison-key="p1" />
      </section>
    </template>

    <template v-else>
    <!-- Hero Section -->
    <section class="page-content">
      <div class="title-box">
        <p style="font-size: 3vw;font-weight: 600;">ANOVATOR A5</p>
        <p style="font-size: 1vw;">Comprehensive body composition analyzer</p>
      </div>
      <div class="features-box">
        <img class="feature-img" src="/static/images/product/a5-main.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/a5-main2x.png" alt="" />
      </div>
      <div class="scroll-mouse" style="bottom: -6%;" v-show="showScrollMouse">
          <img style="width: 30px;height: 30px;" src="/static/images/mouse-w.png"/>
          <p style="color: #FFFFFF;font-size: 12px;margin-top: 10px;">Scroll Mouse</p>
        </div>
    </section>

    <!-- Perfect Body Section -->
    <section class="page-content">
      <div class="features-box">
        <img class="feature-img" src="/static/images/product/a5-main.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/a5-module1-2x.png" alt="" />
      </div>
      <div class="title-box">
        <p class="text_10 bold-text">Perfect body</p>
        <p style="padding: 0 20px;font-size: 15px;font-family: MiSans-Regular;">A5 supports 12 functions, comprehensive detection of body risk, professional<br> version of body composition detection instrument</p>
      </div>
      <div class="function-box">
        <div v-for="func in functions" :key="func">{{ func }}</div>
      </div>
    </section>

    <!-- HD Screen Section -->
    <section class="page-content">
      <div class="left-title-box">
        <span class="large-number">32</span><span class="unit">&nbsp; INCH</span><br />
        <p class="feature-title bold-text">HD SCREEN</p>
        <p class="feature-desc">Immersive body testing <br>IPS HD Touch</p>
      </div>
      <div class="features-box">
        <img class="feature-img mobile-adjust" src="/static/images/product/a5-jishen.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/a5-jishenx2.png" alt="" />
      </div>
    </section>

    <!-- Black Tempered Glass Section -->
    <section class="page-content">
      <div class="rightB-title-box">
        <p class="feature-title bold-text">Black <br>tempered glass</p>
        <p class="feature-desc">Highlight the beauty of industrial technology, minimalist high-end fashion</p>
      </div>
      <div class="features-box">
        <img class="feature-img mobile-adjust" src="/static/images/product/a5-dizuo.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/a5-dizuox2.png" alt="" />
      </div>
    </section>

    <!-- AI Camera Section -->
    <section class="page-content">
      <div class="left-title-box">
        <span class="large-number">AI</span><br />
        <p class="feature-title bold-text" style="text-align: left;">SMART VISUAL<br> CAMERA <br>1080P</p>
      </div>
      <div class="features-box">
        <img class="feature-img mobile-adjust" src="/static/images/product/a5-camera.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/a5-camera2x.png" alt="" />
      </div>
    </section>

    <!-- Ultrasonic Sensor Section -->
    <section class="page-content" style="margin-top: 10px;">
      <div class="rightB-title-box">
        <p class="text_10 bold-text" style="text-align: left;padding-left: 20px;">Ultrasonic <br> sensor</p>
        <table class="param-box">
          <tr>
            <td>50K Hz</td>
            <td>5mm</td>
          </tr>
          <tr>
            <td>Center frequency</td>
            <td>Measurement accuracy</td>
          </tr>
        </table>
      </div>
      <div class="features-box">
        <img class="feature-img mobile-adjust" src="/static/images/product/a5-dingpeng.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/a5-dingpengx2.png" alt="" />
      </div>
    </section>

    <!-- Horizontal Wave Sensor Section -->
    <section class="page-content" style="margin-top: 10px;">
      <div class="features-box">
        <img class="feature-img" src="/static/images/product/a5-spbdcgq.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/a5-spbdcgq2x.png" alt="" />
      </div>
      <div class="overlap-box">
        <img class="overlap-img" src="/static/images/product/curve.png" alt="Curve" />
      </div>
      <div class="title-box">
        <p class="text_10 bold-text">Horizontal wave sensor</p>
      </div>
    </section>

    <!-- Balance Assessment Section -->
    <section class="page-content" style="margin-top: 10px;">
      <div class="right-title-box txt-adjust">
        <span class="text_24 bold-text">Balance <br>Assessment</span>
        <p class="balance-desc" style="margin-top: 20px;">A high-precision horizontal Angle sensor is used to measure the shaking <br>amplitude of the human body and evaluate the strength of the balance <br>ability. This evaluation directly reflects the muscle development and control <br>status, and provides scientific data support for subsequent training.</p>
      </div>
      <div class="features-box">
        <img style="width: 80vw;margin: 0 auto;" class="feature-img mobile-adjust txt-adjust balance-img" src="/static/images/product/a5-sgcs.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/a5-sgcsx2.png" alt="" />
      </div>
    </section>

    <!-- Physical Risk Assessment Section -->
    <section class="page-content" style="margin-top: 10px;">
      <div class="left-title-box" style="bottom: 35%;margin-top: 50px;">
        <span class="text_10 bold-text">Physical <br>risk assessment</span>
        <br><br>
        <div class="tzt-item" v-for="risk in riskItems" :key="risk">{{ risk }}</div>
      </div>
      <div class="features-box">
        <img class="feature-img tzt-img" src="/static/images/product/a5-tzt.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/a5-tztx2.png" alt="" />
      </div>
    </section>

    <!-- Healthy Companion Section -->
    <section class="page-content">
      <div class="title-box txt-will">
        <span class="bold-text">A5 will be <br> your healthy companion</span>
      </div>
      <div class="features-box">
        <img class="feature-img mobile-adjust" src="/static/images/product/a5-will.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/a5-willx2.png" alt="" />
      </div>
    </section>

    <!-- Medical Grade Section -->
    <div class="container medical-section">
      <div class="pj-box">
        <span class="text_24 bold-text">Medical grade</span>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <img src="/static/images/product/a5-xy.png" alt="Blood Oxygen" />
          <div class="img-desc">
            <p class="desc-title bold-text">Blood oxygen</p>
            <p class="desc-text">
              One minute resting heart rate and blood oxygen concentration were measured to assess the strength of cardiopulmonary function, 
              providing accurate data support for daily training intensity planning.
            </p>
          </div>
        </div>
        <div class="col-lg-6">
          <img src="/static/images/product/a5-xya.png" alt="Blood Pressure" />
          <div class="img-desc">
            <p class="desc-title bold-text">Blood pressure measurement</p>
            <p class="desc-text">
              Medical-grade blood pressure measurement to monitor exercise risk. Eliminate high blood pressure, 
              women's menstrual exercise risk, make exercise more comfortable.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Technical Specifications Section -->
    <div style="background-color: #000000;padding-bottom: 10px;">
      <div class="container">
        <div class="tb-title">
          TECHNICAL SPECIFICATIONS:
        </div>
        
        <table class="tb technical-tb">
          <tr v-for="(row, index) in technicalSpecs" :key="index">
            <template v-if="row[1] === ''">
              <td class="tb-key" colspan="2">{{ row[0] }}</td>
            </template>
            <template v-else>
              <td class="tb-key">{{ row[0] }}</td>
              <td class="tb-key">{{ row[1] }}</td>
            </template>
          </tr>
        </table>
        
        <h4 style="margin-top: 50px;margin-bottom: 20px;color: #FFFFFF;">A5 Body Composition Analyzer</h4>
        <table class="tb product-parameters">
          <tr v-for="(param, index) in productParameters" :key="index">
            <td class="tb-col1" v-if="param.rowspan" :rowspan="param.rowspan">{{ param.category }}</td>
            <td class="tb-col2">{{ param.label }}</td>
            <td class="tb-col3" v-html="param.value"></td>
          </tr>
        </table>
      </div>
    </div>

    <!-- 3D Product View Section -->
    <div class="product-3d-section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <h2 class="section-title text-center" style="text-transform: uppercase;">A5 3D Product View</h2>
            <div class="iframe-container">
              <iframe 
                src="/static/web/a5/a5.html" 
                width="100%" 
                height="700px" 
                frameborder="0"
                class="product-iframe"
              ></iframe>
              <p class="iframe-desc">Drag to rotate • Double-click for fullscreen</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </template>
  </div>
</template>

<script>
import { lazyLoadingMixin } from '@/mixins/lazyLoading'
import PSeriesCompare from '@/components/PSeriesCompare.vue'

const { siteLanguageMixin } = require('@/utils/site-language.js')
const { getA5ProductContent } = require('@/data/a5-p3-content.cjs')
const { requestContactModal } = require('@/utils/contact-modal.cjs')

export default {
  name: 'A5',
  components: { PSeriesCompare },
  mixins: [lazyLoadingMixin, siteLanguageMixin],
  data() {
    return {
      showScrollMouse: true,
      functions: [
        'Body composition analysis',
        'Athletic capacity Analysis',
        'Sp02',
        'Sports safety Analysis',
        'Balance Assessment',
        'Heart Rate Test',
        'Response Assessment',
        'Body posture Analysis',
        'Detection Data Analysis',
        'Visual acuity Assessment',
        'Shoulder Joint Range of motion Evaluation Function',
        'Test Report'
      ],
      riskItems: [
        'High and low shoulders',
        'X/O legs',
        'Hunchback',
        'Pelvis tilted forward'
      ],
      technicalSpecs: [
        ['User ID Login/Phone Number Login', 'On Screen Results'],
        ['Printable Results', 'Handle Grips'],
        ['Height', 'Weight'],
        ['BMI', 'Body Fat Percentage'],
        ['Muscle Mass', 'Visceral Fat Area'],
        ['Subcutaneous Fat Area', 'Protein Content'],
        ['Total Body Water', 'Skeletal Muscle'],
        ['BMR(kcal)', 'Obesity Degree (%)'],
        ['Desirable Weight', 'Weight Control'],
        ['Fat Control', 'Muscle Control'],
        ['Segmental Muscle', 'Segmental Body Fat'],
        ['Body Type Classification', 'Balance Test'],
        ['lung Capacity Test', 'Fat-Free Body'],
        ['Bone Mass', 'WHR'],
        ['Body Age', 'SpO2 %'],
        ['Blood Pressure Test', 'Exercise Intensity'],
        ['Vision Test', 'Body Posture Analysis'],
        ['Total Energy Expenditure (kcal)', 'Calorie Consumption (kcal/hour)'],
        ['Expected Fat Burning (kg)', 'Target Body Fat'],
        ['Exercise Program Advice', 'Estimated Completion Period'],
        ['Body Composition History', 'Pervious Data Comparison'],
        ['Responsiveness Test', '']
      ],
      productParameters: [
        { category: 'Screen Host', label: 'Brand', value: 'Anovator', rowspan: 7 },
        { label: 'Product Name', value: 'Body Composition Analyzer' },
        { label: 'Model', value: 'A5' },
        { label: 'Color', value: 'Black' },
        { label: 'Operating System', value: 'Android 7.1' },
        { label: 'Camera', value: '1080P' },
        { label: 'Material', value: 'Tempered Glass Led Screen + Aluminum Alloy' },
        { category: 'Size & Weight', label: 'Product Size', value: 'Host: 1700mm*460mm<br />Base: 108mm*480mm*900mm<br />Bracket: 200*451mm*600', rowspan: 3 },
        { label: 'Package Size', value: 'Host: 1810mm*220mm*610mm<br />Base: 1010mm*577mm*180mm<br />Bracket: 570mm*437mm*525mm' },
        { label: 'Weight', value: '67KG' },
        { category: 'Display Screen', label: 'Screen Size', value: '32 Inch', rowspan: 2 },
        { label: 'Screen Type', value: '1080*1920 IPS HD Touch' },
        { category: 'Technical Parameters', label: 'Measurement methods', value: '8-point contact electrodes, multi-frequency bioelectrical impedance analysis technology', rowspan: 6 },
        { label: 'Frequency', value: '20,100 kHz' },
        { label: 'Electric Current', value: '<280uA' },
        { label: 'Power consumption', value: '60W' },
        { label: 'Height Measurement', value: 'High Frequency Ultrasonic Sensing' },
        { label: 'Spirometry', value: 'High Precision Air Pressure Sensor' },
        { category: 'Function parameter', label: 'Report', value: 'Phone/Paper Print Report/Web', rowspan: 8 },
        { label: 'Voltage', value: 'Input: AC 220V，50/60Hz <br />Output：DC 12V,7A' },
        { label: 'Transmission Port', value: 'USB2.0/Bluetooth/Wired/Wireless' },
        { label: 'Height Range', value: '80-200cm' },
        { label: 'Weight Range', value: '0-200kg' },
        { label: 'Age Range', value: '3-99 years old' },
        { label: 'Operating Environment', value: 'Internet Connection Required <br />Temperature: 10-40℃, Humidity: 30%-75% <br />Do not place the device by the window to avoid direct sunlight.<br />Do not shine direct light on the device screen.' },
        { label: 'Warranty', value: '1 Years' }
      ],
      p3FeatureSections: [
        { key: 'screen', image: '/static/images/product/p3/screen.png', align: 'left', title: '高清屏幕', description: '沉浸式体测 / IPS高清触控' },
        { key: 'glass', image: '/static/images/product/p3/glass.png', align: 'right', title: '黑色钢化玻璃', description: '彰显工业科技之美，演绎极简高端美学' },
        { key: 'camera', image: '/static/images/product/p3/camera.png', align: 'left', kicker: 'AI', title: '智能视觉摄像头', description: '1080P' },
        { key: 'ultrasonic', image: '/static/images/product/p3/ultrasonic.png', align: 'right', title: '超声波传感器', metrics: [{ value: '50K Hz', label: '中心频率' }, { value: '5mm', label: '测量精度' }] },
        { key: 'wave', image: '/static/images/product/p3/wave.png', align: 'center', title: '水平波动传感器' },
        { key: 'balance', image: '/static/images/product/p3/balance.png', align: 'right', title: '平衡能力评估', description: '采用高精度水平角度传感器，测量人体晃动幅度并评估平衡能力。评估结果可直观反映肌肉发展与控制状态，为后续训练提供科学的数据支持。' },
        { key: 'posture', image: '/static/images/product/p3/posture.png', align: 'left', title: '体态风险评估' },
        { key: 'companion', image: '/static/images/product/p3/companion.png', align: 'center', title: 'P3将成为您的健康伙伴' }
      ]
    }
  },
  computed: {
    isChineseProduct() {
      return this.currentLanguage === 'ZH'
    },
    productContent() {
      return getA5ProductContent(this.currentLanguage)
    }
  },
  watch: {
    currentLanguage() {
      this.updateDocumentTitle()
    }
  },
  mounted() {
    this.updateDocumentTitle();
    this.handleScrollMouseVisibility();
    window.addEventListener('scroll', this.handleScrollMouseVisibility);
    
    // 20秒后自动隐藏
    setTimeout(() => {
      this.showScrollMouse = false;
    }, 20000);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScrollMouseVisibility);
  },
  methods: {
    openContactModal(event) {
      requestContactModal(event?.currentTarget)
    },
    updateDocumentTitle() {
      document.title = `${this.productContent.model} - Anovator`
    },
    handleScrollMouseVisibility() {
      if (window.scrollY > 100) {
        this.showScrollMouse = false;
      }
    }
  }
}
</script>

<style scoped>

.a5-page {
  background-color: #000000;
}

.page-content {
  position: relative;
  width: 100vw;
  height: 100%;
}

.features-box {
  width: 100%;
  height: 100%;
}

.feature-img {
  display: block;
  width: 100vw;
  height: calc(100vh - 90px);
  object-fit: cover;
  object-position: center;
  margin: 0;
  padding: 0;
}

.title-box {
  position: absolute;
  width: 100%;
  top: 140px;
  text-align: center;
  z-index: 10;
  color: #FFFFFF;
}

.scroll-mouse {
  position: absolute;
  bottom: 5%;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}

.function-box {
  position: relative;
  bottom: 8vw;
  width: 80%;
  margin: 0 auto;
}

.function-box div {
  display: inline-block;
  font-size: 15px;
  border-radius: 25px;
  padding: 12px 20px;
  background-color: rgba(26, 26, 26, 1);
  margin-right: 20px;
  margin-top: 10px;
  color: #FFFFFF;
}

.text_10 {
  background-image: linear-gradient(
    360deg,
    rgba(192, 214, 255, 1) 0,
    rgba(238, 242, 255, 1) 100%
  );
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  text-transform: uppercase;
  font-family: MiSans-Bold;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.bold-text {
  font-weight: 600;
  font-size: 45px !important;
  line-height: 55px !important;
  text-transform: uppercase;
  font-family: MiSans-Bold;
  color: #FFFFFF;
}

.text_24 {
  background-image: linear-gradient(
    225deg,
    rgba(50, 197, 255, 1) 0,
    rgba(182, 32, 224, 1) 51.258389%,
    rgba(247, 181, 0, 1) 100%
  );
  width: 122px;
  height: 127px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 96px;
  text-transform: uppercase;
  font-family: MiSans-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 127px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.left-title-box {
  position: absolute;
  left: 20%;
  bottom: 45%;
  z-index: 10;
}

.right-title-box {
  position: absolute;
  right: 25%;
  top: 30%;
  z-index: 10;
}

.rightB-title-box {
  position: absolute;
  right: 10%;
  bottom: 15%;
  z-index: 10;
}

.overlap-box {
  position: absolute;
  text-align: center;
  width: 100%;
  top: 25%;
  z-index: 10;
}

.overlap-img {
  width: 38vw;
}

.param-box {
  width: 130%;
  color: #FFFFFF;
  border: none;
}

.param-box td {
  border: none;
}

.param-box tr:first-child {
  font-size: 28px;
  font-weight: 600;
}

.tzt-item {
  display: inline-block;
  padding: 10px 20px;
  color: #FFFFFF;
  text-align: center;
  border: 1px solid #979797;
  border-radius: 5px;
  margin-bottom: 10px;
  margin-right: 10px;
}

.balance-desc {
  font-family: MiSans-Bold;
  font-size: 18px;
  margin-bottom: 10px;
  color: #FFFFFF;
}

.txt-will {
  top: 35vh;
  text-align: center;
  padding: 20px;
  color: #FFFFFF;
}

.txt-will span {
  color: #FFFFFF;
  font-weight: 100;
}

.pj-box {
  position: relative;
  width: 100%;
  height: 300px;
  text-align: center;
  padding: 150px 0;
  color: #FFFFFF;
}

.img-desc {
  padding-top: 20px;
  color: #FFFFFF;
}

.img-desc p {
  color: #FFFFFF;
}

.tb-title {
  width: 100%;
  height: 300px;
  padding-top: 230px;
  font-size: 30px;
  font-weight: 600;
  color: #FFFFFF;
  line-height: 35px;
}

.tb {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  margin-bottom: 50px;
  color: #FFFFFF;
}

.tb th, .tb td {
  border: 1px solid #3F3F3F;
  padding: 15px;
}

.tb tr {
  height: 40px;
}

.tb-key {
  width: 50%;
  background-image: url('../../../public/static/images/checkmark.png');
  background-repeat: no-repeat;
  background-size: 22px;
  background-position-y: 50%;
  background-position-x: 97%;
  padding-right: 30px;
}

.tb-col1 {
  width: 20%;
  font-weight: 600;
  text-align: center;
}

.tb-col2 {
  width: 30%;
  text-align: left;
}

.tb-col3 {
  width: 50%;
  text-align: left;
}

.product-3d-section {
  background-color: #f8f9fa;
  padding: 60px 0;
  margin-top: 60px;
}

.iframe-container {
  background: white;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  padding: 20px;
  margin: 0 auto;
}


.a5-container {
  background-color: #000000;
  min-height: 100vh;
}

/* Global text color for black background */
p, span, div, td, th {
  color: #FFFFFF;
}


h1, h2, h3, h4, h5, h6, .title, .heading {
  font-family: 'MiSans-Bold', sans-serif;
}

.text_25 {
  font-size: 25px;
  font-family: MiSans-Bold;
  font-weight: 700;
  color: #FFFFFF;
}

.balance-desc {
  font-family: 'MiSans-Regular', sans-serif;
  font-size: 16px;
  line-height: 1.6;
}

.img-desc {
  font-family: 'MiSans-Regular', sans-serif;
}

.tb, .tb th, .tb td {
  font-family: 'MiSans-Regular', sans-serif;
}

.product-iframe {
  border: none;
  border-radius: 10px;
  min-height: 300px;
}

.iframe-desc {
  text-align: center;
  margin-top: 15px;
  color: #666;
  font-size: 14px;
}
.large-number{
    background-image: linear-gradient(225deg, rgba(50, 197, 255, 1) 0, rgba(182, 32, 224, 1) 51.258389%, rgba(247, 181, 0, 1) 100%);
    width: 122px;
    height: 127px;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 96px;
    text-transform: uppercase;
    font-family: MiSans-Bold;
    font-weight: 700;
    text-align: left;
    white-space: nowrap;
    line-height: 127px;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.feature-title{
    background-image: linear-gradient(360deg, rgba(192, 214, 255, 1) 0, rgba(238, 242, 255, 1) 100%);
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    text-transform: uppercase;
    font-family: MiSans-Bold;
    font-weight: 700;
    text-align: center;
    white-space: nowrap;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}


@media (max-width: 768px) {
  .txt-adjust {
    text-align: center !important;
  }
  
  .txt-will {
    top: 20vh !important;
  }
  
  .bold-text {
    font-size: 30px !important;
    line-height: 35px !important;
  }
  
  .param-box {
    width: 100% !important;
  }
  
  .balance-desc {
    font-size: 14px !important;
    padding: 0 20px;
  }
  
  .left-title-box, .right-title-box, .rightB-title-box {
    position: relative !important;
    left: auto !important;
    right: auto !important;
    bottom: auto !important;
    top: auto !important;
    text-align: center !important;
    padding: 20px;
  }
  
  .function-box {
    width: 95% !important;
    bottom: 5vw !important;
  }
  
  .function-box div {
    font-size: 13px !important;
    padding: 8px 15px !important;
    margin-right: 10px !important;
  }
  
  .overlap-img {
    width: 60vw !important;
  }
  
  .tb-title {
    height: 200px !important;
    padding-top: 150px !important;
    font-size: 24px !important;
  }
  
  /* 优化技术规格表格在移动端的显示 */
  .container {
    padding: 0 10px !important;
  }
  
  .tb {
    font-size: 11px !important;
    margin: 10px 0 !important;
  }
  
  .tb th, .tb td {
    padding: 8px 5px !important;
    font-size: 11px !important;
    line-height: 1.3 !important;
    word-wrap: break-word !important;
  }
  
  .tb-key {
    background-size: 16px !important;
    background-position-x: 95% !important;
    padding-right: 20px !important;
  }
  
  .tb-col1 {
    width: 25% !important;
    font-size: 10px !important;
  }
  
  .tb-col2 {
    width: 35% !important;
    font-size: 10px !important;
  }
  
  .tb-col3 {
    width: 40% !important;
    font-size: 10px !important;
  }
  
  /* 页面内容区域移动端优化 */
  .page-content {
    flex-direction: column !important;
    padding: 40px 15px !important;
    min-height: auto !important;
  }
  
  .features-box {
    margin: 20px 0 !important;
    order: 2;
  }
  
  .large-number {
    font-size: 60px !important;
    width: 80px !important;
    height: 80px !important;
    line-height: 80px !important;
  }
  
  .unit {
    font-size: 16px !important;
  }
  
  .feature-title {
    font-size: 20px !important;
    line-height: 24px !important;
  }
  
  .feature-desc {
    font-size: 14px !important;
    line-height: 1.4 !important;
  }
  
  /* 3D产品展示区域移动端优化 */
  .product-3d-section {
    padding: 40px 0 !important;
    margin-top: 40px !important;
  }
  
  .iframe-container {
    padding: 15px !important;
    margin: 0 10px !important;
  }
  
  .product-iframe {
    height: 400px !important;
    min-height: 300px !important;
  }
  
  .section-title {
    font-size: 20px !important;
    margin-bottom: 20px !important;
  }
  
  .pj-box {
    height: 200px !important;
    padding: 100px 0 !important;
  }
  
  .img-desc {
    padding: 10px !important;
  }
  
  .img-desc p {
    font-size: 14px !important;
  }
  .mobile-adjust{
    height: auto;
  }
  .tzt-img{
    height: 30vh;
  }
}
.iframe-desc{
  color: #4d4d4d;
}

/* 4K and large screen optimization */
@media (min-width: 1920px) {
  .feature-img, .feature-img2 {
    width: 100vw !important;
    max-width: none !important;
    margin-left: calc(-50vw + 50%) !important;
    margin-right: calc(-50vw + 50%) !important;
  }
  
  .features-box {
    width: 100vw !important;
    margin-left: calc(-50vw + 50%) !important;
    margin-right: calc(-50vw + 50%) !important;
  }
  
  .overlap-img {
    width: 100vw !important;
    max-width: none !important;
    margin-left: calc(-50vw + 50%) !important;
    margin-right: calc(-50vw + 50%) !important;
  }
}

/* P3 uses the same route as A5, but follows the dedicated Chinese product design. */
.p3-page {
  padding-top: var(--global-header-height, 64px);
  min-height: 100vh;
  overflow: hidden;
  color: #fff;
  font-family: MiSans-Regular, Arial, sans-serif;
}

.p3-subnav {
  position: relative;
  z-index: 20;
  display: none;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 50px;
  padding: 0 max(16px, calc((100vw - 1296px) / 2));
  background: #191b1d;
  color: #fff;
  font-size: 12px;
}

.p3-subnav a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 66px;
  min-height: 24px;
  padding: 3px 14px;
  border-radius: 67px;
  background: #fff;
  color: #000;
  font-size: 10px;
  text-decoration: none;
}

.p3-hero {
  position: relative;
  width: 100%;
  height: 770px;
  overflow: hidden;
}

.p3-hero > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.p3-hero__copy {
  position: absolute;
  top: 58px;
  left: 50%;
  width: min(100% - 32px, 680px);
  transform: translateX(-50%);
  text-align: center;
}

.p3-hero__copy h1,
.p3-hero__copy p,
.p3-section-heading h2,
.p3-section-heading p,
.p3-feature-copy h2,
.p3-feature-copy p,
.p3-medical-section h2,
.p3-medical-section h3,
.p3-medical-section p,
.p3-services-section h2,
.p3-services-section h3,
.p3-services-section p,
.p3-compare-section h2 {
  margin: 0;
  color: #fff;
}

.p3-hero__copy h1 {
  font-family: MiSans-Bold, Arial, sans-serif;
  font-size: 40px;
  line-height: 55px;
  font-weight: 700;
}

.p3-hero__copy p {
  margin-top: 8px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 16px;
  line-height: 22px;
}

.p3-scroll-mouse {
  position: absolute;
  bottom: 88px;
  left: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  transform: translateX(-50%);
  color: #979797;
  font-size: 12px;
}

.p3-scroll-mouse img {
  width: 30px;
  height: 30px;
}

.p3-functions-section,
.p3-feature-section {
  position: relative;
  width: min(100%, 1440px);
  height: 710px;
  margin: 0 auto;
  overflow: hidden;
  background: #000;
}

.p3-functions-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 92px 182px 74px;
}

.p3-section-heading {
  width: 1076px;
}

.p3-section-heading h2,
.p3-feature-copy h2,
.p3-medical-section > h2,
.p3-services-section header h2,
.p3-compare-section > h2 {
  font-family: MiSans-Bold, Arial, sans-serif;
  font-size: 40px;
  line-height: 55px;
  font-weight: 700;
}

.p3-section-heading h2,
.p3-feature-copy h2,
.p3-medical-section > h2 {
  background: linear-gradient(0deg, #c0d6ff 0%, #eef2ff 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.p3-section-heading p {
  width: 530px;
  margin-top: 18px;
  font-size: 14px;
  line-height: 22px;
}

.p3-function-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px 24px;
  width: 1076px;
  margin-top: 64px;
}

.p3-function-grid span {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  border-radius: 25px;
  background: linear-gradient(180deg, rgba(44, 44, 44, 0.72), rgba(10, 10, 10, 0.35));
  font-size: 12px;
  text-align: center;
}

.p3-feature-section > img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.p3-feature-copy {
  position: absolute;
  z-index: 2;
  width: 440px;
}

.p3-feature-copy--left {
  top: 218px;
  left: 182px;
  text-align: left;
}

.p3-feature-copy--right {
  top: 218px;
  right: 182px;
  text-align: left;
}

.p3-feature-copy--center {
  top: 86px;
  left: 50%;
  width: 760px;
  transform: translateX(-50%);
  text-align: center;
}

.p3-feature-description {
  margin-top: 18px !important;
  color: rgba(255, 255, 255, 0.72);
  font-size: 14px;
  line-height: 22px;
}

.p3-feature-kicker,
.p3-number strong {
  color: #ef0a6a;
  font-family: MiSans-Bold, Arial, sans-serif;
  font-size: 68px;
  line-height: 1;
}

.p3-number {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  margin-bottom: 16px !important;
}

.p3-number span {
  padding-bottom: 8px;
  font-size: 14px;
}

.p3-feature-metrics {
  display: flex;
  gap: 56px;
  margin-top: 24px;
}

.p3-feature-metrics p {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.p3-feature-metrics strong {
  font-size: 28px;
}

.p3-feature-metrics span {
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
}

.p3-risk-list {
  display: grid;
  grid-template-columns: repeat(2, 120px);
  gap: 10px;
  margin-top: 24px;
}

.p3-risk-list span {
  padding: 9px 10px;
  border: 1px solid #979797;
  border-radius: 5px;
  font-size: 12px;
  text-align: center;
}

.p3-feature-section--companion .p3-feature-copy {
  top: 82px;
}

.p3-medical-section,
.p3-services-section,
.p3-compare-section {
  width: min(100%, 1440px);
  margin: 0 auto;
  padding: 96px 72px;
  background: #000;
}

.p3-medical-section > h2,
.p3-services-section > header,
.p3-compare-section > h2 {
  text-align: center;
}

.p3-medical-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  width: 1076px;
  margin: 48px auto 0;
}

.p3-medical-grid article {
  overflow: hidden;
  border-radius: 24px;
  background: #121212;
}

.p3-medical-grid img {
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
}

.p3-medical-grid h3,
.p3-medical-grid p {
  padding-right: 28px;
  padding-left: 28px;
}

.p3-medical-grid h3 {
  margin-top: 24px;
  font-size: 20px;
}

.p3-medical-grid p {
  margin-top: 12px;
  margin-bottom: 32px;
  color: rgba(255, 255, 255, 0.68);
  font-size: 14px;
  line-height: 22px;
}

.p3-services-section header p {
  margin-top: 12px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
}

.p3-services-section article {
  display: flex;
  align-items: center;
  gap: 76px;
  width: 1076px;
  min-height: 620px;
  margin: 52px auto 0;
}

.p3-services-section article.reverse {
  flex-direction: row-reverse;
}

.p3-services-section article > img {
  width: 56%;
  max-height: 570px;
  object-fit: contain;
}

.p3-service-copy {
  flex: 1;
}

.p3-service-copy > span {
  color: #ef0a6a;
  font-size: 16px;
}

.p3-service-copy h3 {
  margin-top: 18px;
  font-family: MiSans-Bold, Arial, sans-serif;
  font-size: 28px;
  line-height: 38px;
}

.p3-service-copy p {
  margin-top: 16px;
  color: rgba(255, 255, 255, 0.65);
  font-size: 14px;
  line-height: 22px;
}

.p3-compare-section {
  min-height: 760px;
}

.p3-compare-card {
  width: 420px;
  margin: 52px auto 0;
  overflow: hidden;
  border: 1px solid #292929;
  border-radius: 20px;
  background: #111;
}

.p3-compare-card img {
  display: block;
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: contain;
}

.p3-compare-card div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 24px 24px;
}

.p3-compare-card strong {
  font-size: 24px;
}

.p3-compare-card span {
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
}

@media (min-width: 3200px) {
  .p3-hero {
    height: 2053.333px;
  }

  .p3-hero__copy {
    top: 86px;
  }

  .p3-scroll-mouse {
    bottom: 88px;
  }
}

@media (max-width: 700px) {
  .p3-subnav {
    display: flex;
    margin-top: 50px;
    padding: 0 16px;
  }

  .p3-hero {
    height: 770px;
  }

  .p3-hero > img {
    width: 1000px;
    max-width: none;
    margin-left: calc((100% - 1000px) / 2);
  }

  .p3-hero__copy {
    top: 58px;
  }

  .p3-hero__copy h1 {
    font-size: 40px;
    line-height: 55px;
    white-space: nowrap;
  }

  .p3-scroll-mouse {
    display: none;
  }

  .p3-functions-section {
    height: 631px;
    padding: 60px 16px 48px;
    justify-content: flex-start;
  }

  .p3-section-heading,
  .p3-function-grid {
    width: 100%;
  }

  .p3-section-heading h2,
  .p3-feature-copy h2,
  .p3-medical-section > h2,
  .p3-services-section header h2,
  .p3-compare-section > h2 {
    font-size: 40px;
    line-height: 55px;
  }

  .p3-section-heading p {
    width: 100%;
    margin-top: 18px;
    font-size: 14px;
  }

  .p3-function-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    margin-top: 28px;
  }

  .p3-function-grid span {
    height: 50px;
    padding: 0 8px;
  }

  .p3-feature-section {
    width: 100%;
    height: 631px;
  }

  .p3-feature-section > img {
    width: 100%;
    object-fit: cover;
  }

  .p3-feature-copy,
  .p3-feature-copy--left,
  .p3-feature-copy--right,
  .p3-feature-copy--center {
    top: 44px;
    right: auto;
    left: 16px;
    width: calc(100% - 32px);
    transform: none;
    text-align: left;
  }

  .p3-feature-copy--right {
    top: auto;
    bottom: 44px;
  }

  .p3-feature-copy--center {
    text-align: center;
  }

  .p3-feature-copy h2 {
    font-size: 28px;
    line-height: 38px;
  }

  .p3-feature-description {
    max-width: 320px;
  }

  .p3-feature-section--companion .p3-feature-copy {
    top: 44px;
  }

  .p3-medical-section,
  .p3-services-section,
  .p3-compare-section {
    width: 100%;
    padding: 70px 16px;
  }

  .p3-medical-grid {
    grid-template-columns: 1fr;
    gap: 24px;
    width: 100%;
    margin-top: 36px;
  }

  .p3-medical-grid article {
    border-radius: 10px;
  }

  .p3-services-section article,
  .p3-services-section article.reverse {
    flex-direction: column;
    align-items: stretch;
    gap: 28px;
    width: 100%;
    min-height: 0;
    margin-top: 72px;
  }

  .p3-services-section article > img {
    width: 100%;
    max-height: 440px;
  }

  .p3-service-copy h3 {
    font-size: 24px;
    line-height: 34px;
  }

  .p3-compare-section {
    min-height: 650px;
  }

  .p3-compare-card {
    width: min(100%, 400px);
    margin-top: 36px;
  }
}
.p3-page .p3-compare-section { width: 100%; min-height: 0; padding: 0; background: #000; }
</style>
